import MicroModal from 'micromodal';

document.addEventListener('DOMContentLoaded', () => {
  const contentsArea = document.querySelector<HTMLElement>(
    '#modal-photo .modal-photo__contents'
  );
  if (!contentsArea) return;

  const triggers = document.querySelectorAll<HTMLElement>('[data-photo-modal-trigger]');

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const src = trigger.getAttribute('data-photo-src');
      const alt = trigger.getAttribute('data-photo-alt') || '';
      if (!src) return;

      contentsArea.innerHTML = '';
      const img = document.createElement('img');
      img.src = src;
      img.alt = alt;
      img.className = 'modal-photo__image';
      contentsArea.appendChild(img);

      MicroModal.show('modal-photo', {
        disableScroll: true,
        onClose: () => {
          contentsArea.innerHTML = '';
        },
      });
    });
  });
});
